import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Comps from './comps';
import Filters from './filters';
import Header from './header';
import { debouncedSearch, search } from './api';

export const defaultSort = 'distance asc';

export default function CompSelectorBody({ coordinates, selectedComps, type, onSelectedCompsChange }) {
  const defaultQuery = {};
  if (coordinates) {
    defaultQuery.lat = coordinates.latitude;
    defaultQuery.lng = coordinates.longitude;
  }

  const [loading, setLoading] = useState();
  const [page, setPage] = useState(1);
  const [query, setQuery] = useState(defaultQuery);
  const [results, setResults] = useState();
  const [sort, setSort] = useState(defaultSort);

  React.useEffect(() => {
    searchComps(search, type, query, page, sort);
  }, []);

  function updateQuery(changes) {
    const changedQuery = { ...query, ...changes };
    setQuery(changedQuery);
    setPage(1);
    searchComps(debouncedSearch, type, changedQuery, 1, sort);
  }

  function updatePage(page) {
    setPage(page);
    searchComps(search, type, query, page, sort);
  }

  function updateSort(sort) {
    setSort(sort);
    searchComps(search, type, query, page, sort);
  }

  async function searchComps(searcher, type, query, page, sort) {
    setLoading(true);
    setResults(await searcher(type, query, page, sort));
    setLoading(false);
  }

  function select(comp) {
    onSelectedCompsChange([...selectedComps, comp]);
  }

  function deselect(comp) {
    onSelectedCompsChange(selectedComps.filter(selectedComp => selectedComp.id !== comp.id));
  }

  return <React.Fragment>
    <Header
      query={query}
      sort={sort}
      type={type}
      onQueryChange={updateQuery}
      onSortChange={updateSort}
    />

    <div className="d-flex flex-row flex-wrap gap-4">
      <div className="flex-fill">
        <Comps
          loading={loading}
          results={results}
          selectedComps={selectedComps}
          onDeselect={deselect}
          onPageChange={updatePage}
          onSelect={select}
        />
      </div>

      <div style={{ width: 264 }}>
        <Filters
          query={query}
          type={type}
          onChange={updateQuery}
        />
      </div>
    </div>
  </React.Fragment>;
}

CompSelectorBody.propTypes = {
  coordinates: PropTypes.shape({
    latitude: PropTypes.number,
    longitude: PropTypes.number,
  }),
  selectedComps: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
  })).isRequired,
  type: PropTypes.oneOf(['lease', 'sale']).isRequired,
  onSelectedCompsChange: PropTypes.func.isRequired,
};
